//Whoever releases the SDK has to update the version number
const sdkVersion = "2.0.1";

export { sdkVersion };
